function isPromise(value: unknown): value is Promise<unknown> {
  return (
    !!value && Object.prototype.toString.call(value) === '[object Promise]'
  );
}

function isBlob(value: unknown): value is Blob {
  return (
    !!value &&
    typeof (value as Blob).size === 'number' &&
    typeof (value as Blob).type === 'string' &&
    typeof (value as Blob).slice === 'function'
  );
}

function isFile(value: unknown, type = ''): value is File {
  const base =
    isBlob(value) &&
    typeof (value as File).name === 'string' &&
    (typeof (value as File & { lastModifiedDate?: unknown })
      .lastModifiedDate === 'object' ||
      typeof (value as File).lastModified === 'number');

  return type
    ? !!(base && (value as File).type.split('/')[0] === type)
    : !!base;
}

export { isBlob, isFile, isPromise };
